import { gql, useQuery } from "@apollo/client";
import useRequestBeforeLogin from "src/utils/hook/base/useRequestBeforeLogin";

const Q_ActiveCategoryList = gql`
  query getActiveCategoryList {
    activeCategoryList {
      totalCount
      edges {
        node {
          title
          priority
          isActive
          id
          description
          creator
        }
      }
    }
  }
`;

function useGetActiveCategoryList() {
  const { requestConfig } = useRequestBeforeLogin();
  const { loading, error, data, refetch } = useQuery(
    Q_ActiveCategoryList,
    requestConfig({
      module: "AVC_TICKET",
    })
  );

  return { loading, error, data, refetch };
}
export default useGetActiveCategoryList;
